import { useState } from "react";
import SearchPanel from "./SearchPanel";
import type { SearchPanelItem } from "./SearchPanel";
import styles from "./SearchPanel.example.module.scss";

interface SampleItem extends SearchPanelItem {
  readonly kind: "primaryCategory" | "secondaryCategory" | "optionSet" | "option";
  readonly searchText: string;
}

const SAMPLE_ITEMS: readonly SampleItem[] = [
  { id: "1", label: "Kitchen", typeLabel: "Category", kind: "primaryCategory", searchText: "kitchen" },
  {
    id: "2",
    label: "Countertops",
    typeLabel: "Subcategory",
    kind: "secondaryCategory",
    searchText: "kitchen countertops",
  },
  {
    id: "3",
    label: "Granite Countertop",
    typeLabel: "Option Set",
    kind: "optionSet",
    searchText: "granite countertop",
  },
  {
    id: "4",
    label: "Granite Countertop · White Galaxy",
    typeLabel: "Option",
    kind: "option",
    searchText: "granite countertop white galaxy",
  },
  {
    id: "5",
    label: "Granite Countertop · Black Pearl",
    typeLabel: "Option",
    kind: "option",
    searchText: "granite countertop black pearl",
  },
  { id: "6", label: "Bathroom", typeLabel: "Category", kind: "primaryCategory", searchText: "bathroom" },
  {
    id: "7",
    label: "Vanities",
    typeLabel: "Subcategory",
    kind: "secondaryCategory",
    searchText: "bathroom vanities",
  },
  { id: "8", label: "Single Vanity", typeLabel: "Option Set", kind: "optionSet", searchText: "single vanity" },
  {
    id: "9",
    label: "Single Vanity · 36 inch",
    typeLabel: "Option",
    kind: "option",
    searchText: "single vanity 36 inch",
  },
];

function defaultLabelFilter(items: readonly SampleItem[], query: string): readonly SampleItem[] {
  const lowerQuery = query.toLocaleLowerCase().trim();
  if (!lowerQuery) {
    return items;
  }
  return items.filter((item) => item.label.toLocaleLowerCase().includes(lowerQuery));
}

export function BasicExample() {
  const [selected, setSelected] = useState<SampleItem | null>(null);

  return (
    <div style={{ padding: "20px" }}>
      <h3>Basic SearchPanel Example</h3>
      <p style={{ marginBottom: "16px", fontSize: "14px", color: "#666" }}>
        Select an item to see the selection feedback. Type to filter the list.
      </p>
      <div style={{ maxWidth: "400px" }}>
        <SearchPanel
          items={SAMPLE_ITEMS}
          onSelect={setSelected}
          closeModal={() => console.log("Modal closed")}
          filterItems={defaultLabelFilter}
          getItemClassName={(item) => styles[item.kind]}
          title="Search items"
          placeholder="Search…"
        />
      </div>
      {selected && (
        <div style={{ marginTop: "16px", padding: "12px", background: "#f5f5f5", borderRadius: "4px" }}>
          <strong>Selected:</strong> {selected.label} ({selected.typeLabel})
        </div>
      )}
    </div>
  );
}

export default function SearchPanelExamples() {
  return (
    <div>
      <h1>SearchPanel Examples</h1>
      <BasicExample />
    </div>
  );
}
